import React from "react";
import * as colors from "@material-ui/core/colors";
import CheckIcon from "@material-ui/icons/Check";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import ColorBar from "./ColorBar";
import { AddPropertyFieldComponent } from "../property/PropertyField";
import { FastField, Field } from "formik";
import { getFieldStatus } from "./common";

const hues = Object.keys(colors).slice(1);
const shades = [
  900,
  800,
  700,
  600,
  500,
  400,
  300,
  200,
  100,
  50,
  "A700",
  "A400",
  "A200",
  "A100"
];

const styles = () => ({
  colorItem: {
    width: "100%",
    padding: 0
  },
  selected: {
    height: "19px",
    border: "1px solid",
    borderRadius: "4px"
  },
  swatch: {
    width: "100%",
    height: "19px",
    display: "flex"
  },
  noPadding: {
    padding: 0
  },
  expanderRoot: {
    //width: "100%"
    flexGrow: 1 //FIXME
  }
});

const ColorPicker = withStyles(styles, { withTheme: true })(
  ({ label, color, classes, onSetColor, theme, variants, j = 0 }) => (
    <ExpansionPanel classes={{ root: classes.expanderRoot }} elevation={0}>
      <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
        <Grid container spacing={0}>
          <Grid item xs={12}>
            <Typography variant="button">{label}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography component="div" gutterBottom>
              <ColorBar color={color} variants={variants} />
            </Typography>
          </Grid>
        </Grid>
      </ExpansionPanelSummary>
      <ExpansionPanelDetails className={classes.noPadding}>
        <Grid container>
          <Grid item xs={12}>
            <Paper elevation={0}>
              {shades.map(sh => (
                <div key={"shade-" + j++} className={classes.swatch}>
                  {hues.map(hue => {
                    const backgroundColor = colors[hue][sh];
                    const key = label + "-" + backgroundColor;
                    const onClick = () =>
                      onSetColor(
                        theme.palette.augmentColor({ main: backgroundColor })
                      );
                    const contrastColor = theme.palette.getContrastText(
                      backgroundColor
                    );

                    return (
                      <div
                        role="none"
                        key={key}
                        className={classes.colorItem}
                        style={{ backgroundColor }}
                        onClick={onClick}
                      >
                        {color.main === backgroundColor && (
                          <div
                            className={classes.selected}
                            style={{
                              backgroundColor,
                              borderColor: contrastColor
                            }}
                          >
                            <CheckIcon
                              style={{
                                width: "100%",
                                height: "16px",
                                color: contrastColor
                              }}
                            />
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              ))}
            </Paper>
          </Grid>
        </Grid>
      </ExpansionPanelDetails>
    </ExpansionPanel>
  )
);

const ColorField = ({
  name,
  label: labelProp = name,
  required,
  disabled: disabledProp,
  value: valueProp,
  fullWidth,
  labelPlacement,
  fast = true,
  FieldComponent = fast ? FastField : Field,
  ...rest
}) => (
  <FieldComponent name={name}>
    {({ field, form }) => {
      const { error, hasError, disabled, label, value } = getFieldStatus(
        form,
        field,
        valueProp,
        labelProp,
        disabledProp
      );

      return (
        <FormControl error={hasError} required={required} fullWidth={fullWidth}>
          <FormControlLabel
            labelPlacement={labelPlacement}
            control={
              <ColorPicker
                aria-label={label}
                color={value}
                onSetColor={color => {
                  form.setFieldValue(name, color);
                }}
                {...rest}
              />
            }
            label={label}
            disabled={disabled}
          />
          {hasError && <FormHelperText>{error}</FormHelperText>}
        </FormControl>
      );
    }}
  </FieldComponent>
);

AddPropertyFieldComponent("color", ColorField);

export default ColorField;
